/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterIdEntry } from '../../models/work-center-id-entry';

export interface OpenProducedMaterial$Params {
  producedMaterialId: number;
      body: WorkCenterIdEntry
}

export function openProducedMaterial(http: HttpClient, rootUrl: string, params: OpenProducedMaterial$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, openProducedMaterial.PATH, 'post');
  if (params) {
    rb.path('producedMaterialId', params.producedMaterialId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

openProducedMaterial.PATH = '/api/v1/Containers/{producedMaterialId}/Open';
